import { css } from 'styled-components'

/**
 * Shared look for every fixed, floating control on mobile — the Guru launcher,
 * the Building Passport info trigger, the files menu, the units reminder.
 *
 * Pair it with one of the `--bp-float-*` rows from globalStyles for the
 * vertical position, so the controls stack instead of covering each other.
 *
 * `$accent` colours the icon; the shell stays neutral so the buttons read as
 * one family regardless of what they do.
 */
export const FLOATING_BUTTON_SIZE = 46

export const floatingButtonStyle = css`
  box-sizing: border-box;
  bottom: var(--bp-slot, var(--bp-float-1));
  width: ${FLOATING_BUTTON_SIZE}px;
  height: ${FLOATING_BUTTON_SIZE}px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(12, 18, 41, 0.1);
  box-shadow: 0 6px 18px rgba(12, 18, 41, 0.18);
  color: ${({ $accent, theme }) => $accent || theme?.colors?.haiti || '#0C1229'};
  cursor: pointer;
  transition: transform 150ms ease, box-shadow 150ms ease;

  svg {
    width: 24px;
    height: 24px;
    color: inherit;
    fill: currentColor;
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 6px 18px rgba(12, 18, 41, 0.18),
      0 0 0 3px ${({ $accent, theme }) => `${$accent || theme?.colors?.primary || '#D24724'}40`};
  }
`

export default floatingButtonStyle
